import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { UpdateDiscounts } from 'src/app/shop';
import { CartDiscountCode } from 'src/app/shop/models/cart.model';

@Component({
    selector: 'app-discount-form',
    templateUrl: './discount-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DiscountFormComponent implements AfterViewInit, OnInit, OnChanges {
  @Input() discountCodes: CartDiscountCode[] = [];
  @ViewChild('collapsable') collapsable?: ElementRef;

  @Input() discountLoaded: boolean = false;
  @Input() discountLoading: boolean = false;

  discountForm = this.fb.group({
    code: ['', []],
  });

  @Input() collapsed = true;
  collapsableHeight?: string;

  private dict = new FromDictionaryPipe(this.lang);

  constructor(private lang: LanguageService, private fb: FormBuilder, private cd: ChangeDetectorRef, private store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['discountCodes']) {
      this.discountForm.patchValue({ code: this.discountCodes[0]?.code || '' });
    }
  }

  ngOnInit(): void {
    if (this.discountCodes.length) {
      this.discountForm.patchValue({ code: this.discountCodes[0].code });
    }
  }

  ngAfterViewInit(): void {
    this.collapsableHeight = `${this.collapsable?.nativeElement.clientHeight}px`;
    this.cd.detectChanges();
  }

  UpdateDiscounts() {
    this.discountForm.markAllAsTouched();

    if (this.discountForm.valid) {
      this.store.dispatch(
        //Enable to make use of multiple codes at the same time
        //UpdateDiscounts({ discountCodes: [...this.discountCodes.map(a => a.code), this.discountForm.value['code'] || ''] })
        UpdateDiscounts({ discountCodes: [this.discountForm.value['code'] || ''] })
      );
    }
  }

  removeDiscount(discount: CartDiscountCode) {
    const codesAfterUpdate = this.discountCodes.filter(a => a.code !== discount.code).map(a => a.code);

    this.store.dispatch(UpdateDiscounts({ discountCodes: codesAfterUpdate }));
  }

  get applicable() {
    this.collapsableHeight = `${this.collapsable?.nativeElement.clientHeight}px`;

    if (!this.discountCodes.length) {
      return true;
    }
    const code = this.discountCodes.filter(a => a.code === this.discount.code)?.[0];
    return code && code.applicable;
  }

  get discount() {
    return this.discountCodes?.[0];
  }
}
